TS.ns('WL');

WL.securityDocumentStateViewModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) { 
        var me = this;
        me.parent(config);

        var authorizationMatrixRead = me.getDomainProperty('AuthorizationMatrixRead');
         
        if (authorizationMatrixRead) { 
            var cat = authorizationMatrixRead.Commands;

            me.MatrixAuthorizeAllVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                var visible = false;
                var array = $.map(authorizationMatrixRead.SelectedItem(), function (value, index) {
                    return [value];
                });
                var x = Object.keys(authorizationMatrixRead.SelectedItem());
                $.each(x, function (index, value) {
                    if (value.indexOf("UG") !== -1) {
                        if (!array[index]()) {
                            visible = true;
                        }
                    }
                });
                return visible;
            });

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AuthorizeAllSecurityCommand';
            newCmd['Text'] = me.AuthorizeAllSecurityCommandText();
            newCmd['handler'] = '_authorizeAllSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixAuthorizeAllVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);

            me.MatrixUnauthorizeAllVisible = ko.computed(function () {
                if (authorizationMatrixRead.SelectedItem() == null)
                    return false;
                var visible = false;
                var array = $.map(authorizationMatrixRead.SelectedItem(), function (value, index) {
                    return [value];
                });
                var x = Object.keys(authorizationMatrixRead.SelectedItem());
                $.each(x, function (index, value) {
                    if (value.indexOf("UG") !== -1) {
                        if (array[index]()) {
                            visible = true;
                        }
                    }
                });
                return visible;
            });

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'UnauthorizeAllSecurityCommand';
            newCmd['Text'] = me.UnauthorizeAllSecurityCommandText();
            newCmd['handler'] = '_unauthorizeAllSecurity';
            newCmd['IconCode'] = 'ellipsis-v';
            newCmd.InternalVisible = me.MatrixUnauthorizeAllVisible;

            if (!me.ReadOnly())
                cat.push(newCmd);
        }
    },

    _authorizeAllSecurity: function () {
        var me = this;
        me.performServerCommand({
            cmd: 'AuthorizeAllSecurity',
            submitModel: true,
            blockUI: true
        });
    },

    _unauthorizeAllSecurity: function () {
        var me = this;
        me.performServerCommand({
            cmd: 'UnauthorizeAllSecurity',
            submitModel: true,
            blockUI: true
        });
    }

});